<template>
  <div class="small my-3">
    Generation takes 15-45 seconds; you can request a new picture every 30 seconds.
  </div>
</template>

<script>
export default {
  name: 'GenerationNotice'
}
</script>